// useUrlChange.js
import { useEffect } from "react";

export const useUrlChange = (callback) => {
  useEffect(() => {
    const observeUrlChanges = () => {
      const pushState = window.history.pushState;
      const replaceState = window.history.replaceState;

      window.history.pushState = function (...args) {
        const result = pushState.apply(this, args);
        window.dispatchEvent(new Event("pushstate"));
        window.dispatchEvent(new Event("locationchange"));
        return result;
      };

      window.history.replaceState = function (...args) {
        const result = replaceState.apply(this, args);
        window.dispatchEvent(new Event("replacestate"));
        window.dispatchEvent(new Event("locationchange"));
        return result;
      };

      window.addEventListener("popstate", () => {
        window.dispatchEvent(new Event("locationchange"));
      });
    };

    observeUrlChanges();
    window.addEventListener("locationchange", callback);

    return () => {
      window.removeEventListener("locationchange", callback);
    };
  }, [callback]);
};
